import styles from './Summery.module.css'
import { Uniter } from "../../../../helbest";

const Summery = (props) => {
  const { summery } = props;

  return (
    <div className={styles.Summery}>

      <div className={styles.RowItem}>
        <span>Total price</span>
        <span style={{fontWeight: 'bold'}}>{summery.total_quantity}</span>
      </div>

      <div className={styles.RowItem}>
        <span>Number of car services</span>
        <Uniter childSize={14} isBold={true}>
          {summery.total_amount}
        </Uniter>
      </div>

      <div className={styles.Seprator}></div>

      <div className={styles.RowItem}>
        <span>Payable amount</span>

        <Uniter childSize={14} isBold={true}>
          {summery.payable_amount}
        </Uniter>
      </div>
    </div>
  );
};

export default Summery;
